/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { SurveySummary } from '@g17eco/types/scorecard';
import { InitiativeSuggestion, SurveyDates } from '../types/initiativeSuggestion';

export const createSurveyDateEntry = (id?: string, year?: number, month?: number) => {
  return `${id}-${year}-${month}`;
};

const addSurvey = (s: SurveyDates, existingData: Set<string>, initiative: { _id: string }) => {
  const date = new Date(s.effectiveDate);
  existingData.add(createSurveyDateEntry(initiative._id, date.getUTCFullYear(), date.getUTCMonth()))
};

const processInitiative = (initiative: InitiativeSuggestion, existingData: Set<string>) => {

  initiative.surveys?.forEach((s) => {
    addSurvey(s, existingData, initiative);
  })

  initiative.countries?.forEach(country => {
    country.surveys?.forEach((s) => {
      addSurvey(s, existingData, country);
    })
  })
};

export const uniqueSurveyDates = (initiativeSuggestions: InitiativeSuggestion[]) => {
  const existingData = new Set<string>();
  initiativeSuggestions.forEach(initiative => {
    processInitiative(initiative, existingData);
  });

  return existingData
};

export const uniqueSurveyDatesBySurveyListSummary = (surveys: undefined | SurveySummary[]) => {
  const existingData = new Set<string>();
  surveys?.forEach(survey => {
    addSurvey(survey, existingData, survey.initiative);
  });

  return existingData
};
